<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      :model="model"
      entity-name="staff"
      icon="mdi-cash-plus"
    >
      <template #item.checkFiles="{item}">
        <v-btn
          :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
          :icon="!$vuetify.breakpoint.lgAndUp"
          :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
          :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
          color="amber lighten-4 black--text"
          elevation="0"
          small
          @click.stop="checkFiles(item)"
        >
          <template v-if="!$vuetify.breakpoint.lgAndUp">
            <v-icon color="white">
              mdi-cog
            </v-icon>
          </template>
          <template v-if="$vuetify.breakpoint.lgAndUp">
            <div
              :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
              :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
            >
              {{ item.attachment.length > 0 ? $t('ShowFiles') : $t('add') }}
            </div>
          </template>
        </v-btn>
      </template>
      <template #item.secretKey="{item}">
        <v-btn
          :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
          :icon="!$vuetify.breakpoint.lgAndUp"
          :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
          :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
          color="amber lighten-4 black--text"
          elevation="0"
          small
          @click.stop="addSecretKey(item)"
        >
          <template v-if="!$vuetify.breakpoint.lgAndUp">
            <v-icon color="white">
              mdi-cog
            </v-icon>
          </template>
          <template v-if="$vuetify.breakpoint.lgAndUp">
            <div
              :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
              :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
            >
              {{ item.secretKey ? $t('haveFingerKey') : $t('addFingerKey') }}
            </div>
          </template>
        </v-btn>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showFiles"
      max-width="600px"
    >
      <v-card
        class="text-body-1 pa-6"
        elevation="0"
        style="overflow: visible;"
      >
        <div class="d-flex mb-4 align-center justify-center">
          <div class="text-h4 font-weight-bold">
            {{ $t('EmployeeDocument') }}: {{ servantName }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="showFiles = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <template v-if="!alreadySelectedFile">
          <div
            style="display: grid;grid-template-columns: repeat(auto-fill,minmax(144px,1fr));grid-gap: 24px;"
          >
            <v-card
              class="pa-4 d-flex align-center justify-center"
              color="#eee"
              elevation="0"
              height="200"
            >
              <div class="text-center">
                <v-icon size="48">
                  mdi-plus
                </v-icon>
                <div>
                  {{ $t('AddNewFile') }}
                </div>
              </div>
              <v-file-input
                ref="input"
                outlined
                style="opacity: 0; position: absolute; width: 100%; height: 200px; bottom: -70px; "
                type="file"
                @change="choseFile"
              />
            </v-card>
            <div
              v-for="item in fileList"
              :key="item.id"
            >
              <v-card
                elevation="0"
                height="200"
                outlined
                @click="downloadFile(item)"
              >
                <div class="d-flex mb-4 align-center justify-center">
                  <v-spacer />
                  <div>
                    <v-btn
                      icon
                      @click.stop="deleteFiles(item)"
                    >
                      <v-icon>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
                <div class="py-2 text-center">
                  <v-icon size="48">
                    mdi-file-cloud-outline
                  </v-icon>
                  <div>
                    {{ item._metadata.name }}
                  </div>
                  <div>{{ item._metadata.note }}</div>
                </div>
              </v-card>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="d-flex mt-4 flex-column">
            <div>{{ $t('Annotation') }}:</div>
            <v-spacer />
            <v-text-field
              v-model="note"
              dense
              hide-details
              outlined
            />
          </div>
          <v-btn
            :loading="btnLoading"
            block
            class="mt-8"
            color="amber lighten-4 black--text"
            elevation="0"
            @click="submit"
          >
            {{ $t('save') }}
          </v-btn>
        </template>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showSecretKey"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center">
          <page-sub-header>
            {{ $t('verifyFingerKey') }}
          </page-sub-header>
          <v-spacer />
        </div>
        <div>
          <v-text-field
            v-model="secretKey"
            :placeholder="$t('fingerKey')"
            autofocus
            clearable
          />
        </div>
        <v-btn
          class="primary"
          width="100%"
          @click="saveSecretKey"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Servant, { deleteServantFiles, uploadServantFiles } from '@/model/dataLayer/api/tableAndPerson/Servant'
import { showSuccessMessage } from '@/model/utils/utils'
import GlobalConfig from '@/model/global/GlobalSettings'
import { getBaseAndUrlForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import PageSubHeader from '@/views/widget/typography/PageSubHeader.vue'

export default {
  name: 'PersonManagePage',
  components: {
    PageSubHeader,
    IkDataTable
  },
  data: function () {
    return ({
      editItem: null,
      secretKey: '',
      showSecretKey: false,
      fileList: [],
      btnLoading: false,
      servantName: '',
      note: '',
      alreadySelectedFile: null,
      servantId: '',
      showFiles: false,
      model: Servant
    })
  },
  watch: {
    showFiles (val) {
      if (!val) {
        this.alreadySelectedFile = null
        this.servantId = ''
      }
    }
  },
  methods: {
    async saveSecretKey () {
      this.editItem.secretKey = this.secretKey
      await Servant.edit(this.editItem)
      this.showSecretKey = false
      await this.$refs.table.reload()
    },
    addSecretKey (item) {
      this.editItem = item
      this.secretKey = item.secretKey
      this.showSecretKey = true
    },
    async downloadFile (item) {
      const { url } = await getBaseAndUrlForDeviceId(GlobalConfig.DeviceId)
      window.open(url + '/Resource/' + item.filePath)
    },
    async deleteFiles (item) {
      await deleteServantFiles(item.id)
      showSuccessMessage('DeletionSuccessful')
      this.showFiles = false
      await this.$refs.table.reload()
    },
    async submit () {
      this.btnLoading = true
      await uploadServantFiles(this.servantId, this.alreadySelectedFile, { type: this.alreadySelectedFile.type, name: this.alreadySelectedFile.name, note: this.note })
      this.showFiles = false
      await this.$refs.table.reload()
      showSuccessMessage('UploadSuccessful')
      this.btnLoading = false
    },
    async choseFile (event) {
      this.alreadySelectedFile = event
    },
    checkFiles (item) {
      this.servantId = item.id
      this.fileList = item.attachment
      this.fileList.forEach(it => {
        it._metadata = JSON.parse(it.metadata)
      })
      this.servantName = item.name
      this.showFiles = true
    }
  }
}
</script>
<style>
.hiddenText {
  display: inline-block;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hiddenText:hover {
  overflow: visible;
}
</style>
